import { createSlice } from '@reduxjs/toolkit';
import { pageModel } from '../../utils/model';

const initialState = {
    page: pageModel
}

const weightSlice = createSlice({
    name: 'weight',
    initialState,
    reducers: {
        setWeightPageAction: (state, action) => {
            state.page = action.payload
        },
        getWeightPageAction: (state, action) => {
            const content = state.page.content.concat(action.payload.content)
            state.page = { ...action.payload, content }
        },
        addWeightAction: (state, action) => {
            state.page.content.unshift(action.payload)
        },
        updateWeightAction: (state, action) => {
            const content = state.page.content.map((x) => {
                if (x.id === action.payload.id) return action.payload
                else return x
            })
            state.page.content = content
        },
        deleteWeightAction: (state, action) => {
            const content = state.page.content.filter(p => p.id !== action.payload)
            state.page.content = content
        }
    },
});

export const { setWeightPageAction, getWeightPageAction, addWeightAction, updateWeightAction, deleteWeightAction } = weightSlice.actions;
export default weightSlice;